import {
  Box,
  Button,
  Center,
  Image,
  Spacer,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { REPOSITORY } from '../../../api/repository/Repository'
import IconImage from '../../../assets/images/StoreIcon.png'
import { ItemComponent } from './components/ItemComponent'
import { LabelComponent } from './components/LabelComponent'

const cacheOptions = { cacheTime: 50000, staleTime: 50000 }

export default function Locales() {
  const locales =
    useQuery(
      ['newLocales'],
      REPOSITORY.wsEmpresa.dashboard.NewLocales,
      cacheOptions,
    )?.data?.data?.lLocales || []

  console.log(locales)

  return (
    <Box
      w="100%"
      height={507}
      minWidth={420}
      overflow="hidden"
      position="relative"
      backgroundColor="#fff"
      borderRadius="0px 0px 5px 5px"
    >
      <VStack h="100%" w="100%" overflowX="auto">
        {locales.length > 0 ? (
          <VStack w="100%" margin="10px 0px 10px 0px">
            {locales.map((item, index) => (
              <ItemComponent key={index} {...item} />
            ))}
          </VStack>
        ) : (
          <Center w="100%" h="100%">
            <VStack pr={10} pl={10} mb={20}>
              <Image src={IconImage} />
              <Text variant="subtitle2" textAlign="center">
                En la actualidad no tenemos locales nuevos en tu comuna
              </Text>
              <Spacer height={10} />
              <Button
                bg="#EFA329"
                boxShadow={null}
                borderRadius={10}
                width="fit-content"
                borderColor="#EFA329"
              >
                <Text color="#fff" variant="subtitle2">
                  Suma tu local favorito pídelo aquí
                </Text>
              </Button>
            </VStack>
          </Center>
        )}
      </VStack>

      <LabelComponent />
    </Box>
  )
}

Locales.propTypes = {}
